module.exports = __webpack_public_path__ + "62bf3106684c5d6a2a87ae9ea922b509.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Special/Avdelare/img/mil_desk_gray.gif
 ** module id = 459
 ** module chunks = 0
 **/